import { Link, useLocation } from 'react-router-dom';
import type React from 'react';
import LogoTall from '@/components/logo-tall';
import ROUTES from '@/services/routes';
import NVRGLogo from '@/assets/ref_logos/NVRG.jpg';
import RBCZLogo from '@/assets/ref_logos/RBCZ.png';

const Footer: React.FC = () => {
  const d = new Date();
  const year = d.getFullYear();

  const location = useLocation();

  // Check of we op de homepagina zijn
  const isHomePage = location.pathname === ROUTES.HOME;

  return (
    <footer
      className={`w-full bg-header border-t border-header-border text-header-text ${isHomePage && 'md:snap-start'}`}
    >
      <div className="max-w-(--breakpoint-xl) mx-auto px-4 md:px-8 lg:px-12 xl:px-16 py-8">
        <div className="md:flex md:justify-between">
          <div className="mb-6 md:mb-0">
            <Link to="/#home" className="text-4xl text-white">
              <LogoTall className="h-24 sm:h-28 md:h-32 w-auto text-white" />
            </Link>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
            <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-header-text">Therapie</h2>
              <ul>
                <li className="mb-4">
                  <a
                    href={`${ROUTES.THERAPY_FULL}/#individueel`}
                    className="hover:text-header-text-hover hover:underline"
                  >
                    Individuele therapie
                  </a>
                </li>
                <li className="mb-4">
                  <a
                    href={`${ROUTES.THERAPY_FULL}/#relatie`}
                    className="hover:text-header-text-hover hover:underline"
                  >
                    Relatie therapie
                  </a>
                </li>
                <li className="mb-4">
                  <a
                    href={`${ROUTES.THERAPY_FULL}/#systeem`}
                    className="hover:text-header-text-hover hover:underline"
                  >
                    Systeem therapie
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-header-text">Informatie</h2>
              <ul>
                <li className="mb-4">
                  <a
                    href={`${ROUTES.THERAPY_FULL}`}
                    className="hover:text-header-text-hover hover:underline"
                  >
                    Aanbod
                  </a>
                </li>
                <li>
                  <a
                    href={`${ROUTES.THERAPY_FULL}/#tarieven`}
                    className="hover:text-header-text-hover hover:underline"
                  >
                    Tarieven
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mb-6 text-sm font-semibold uppercase text-header-text">Contact</h2>
              <ul>
                <li className="mb-4">
                  <a
                    href={`${ROUTES.CONTACT_FULL}`}
                    className="hover:text-header-text-hover hover:underline"
                  >
                    Adres gegevens
                  </a>
                </li>
                <li>
                  <a
                    href={`${ROUTES.CONTACT_FULL}/#contact`}
                    className="hover:text-header-text-hover hover:underline"
                  >
                    Contactformulier
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* Certificeringen sectie */}
        <div className="my-8 py-6 border-y border-header-border">
          <h3 className="text-center text-sm font-semibold uppercase text-header-text mb-6">
            Certificeringen & Registraties
          </h3>
          <div className="flex justify-center items-center gap-8 flex-wrap">
            <a
              href="https://www.eft.nl"
              target="_blank"
              rel="noreferrer"
              className="group relative"
              title="EFT Certified Therapist"
            >
              <img
                src="https://www.eft.nl/images/eftknop.png"
                alt="Stichting EFT Nederland"
                className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
              />
              <span className="absolute -bottom-5 left-1/2 -translate-x-1/2 text-xs text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                EFT Register Therapeut
              </span>
            </a>
            <a
              href="https://www.nvrg.nl/systeemtherapie"
              target="_blank"
              rel="noreferrer"
              className="group relative"
              title="NVRG Registered Therapist"
            >
              <img
                src={NVRGLogo}
                alt="NVRG - Nederlandse Vereniging voor Relatie- en Gezinstherapie"
                className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
              />
              <span className="absolute -bottom-5 left-1/2 -translate-x-1/2 text-xs text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                NVRG Lid
              </span>
            </a>
            <a
              href="https://www.rbcz.nu/"
              target="_blank"
              rel="noreferrer"
              className="group relative"
              title="RBCZ Registered"
            >
              <img
                src={RBCZLogo}
                alt="RBCZ - Register Beroepsbeoefenaren Complementaire Zorg"
                className="h-16 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity grayscale hover:grayscale-0"
              />
              <span className="absolute -bottom-5 left-1/2 -translate-x-1/2 text-xs text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                RBCZ Geregistreerd
              </span>
            </a>
          </div>
        </div>
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-sm sm:text-center text-gray-300">
            © {year}{' '}
            <a
              href="https://www.clockwork-it.nl"
              className="hover:text-header-text-hover hover:underline"
            >
              Clockwork IT
            </a>
          </span>
          <div className="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
            {/* biome-ignore lint/a11y/useAnchorContent: <explanation> */}
            <a
              href="https://www.instagram.com/praktijkiselda/"
              target="_blank"
              className="text-header-text hover:text-header-text-hover"
              rel="noreferrer"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                  clipRule="evenodd"
                />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/praktijk-iselda/"
              className="text-header-text hover:text-header-text-hover"
              target="_blank"
              rel="noreferrer"
            >
              {/* biome-ignore lint/a11y/noSvgWithoutTitle: <explanation> */}
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 14 14">
                <path
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.574 1.767a1.316 1.316 0 0 1-1.287 1.326A1.346 1.346 0 0 1 .99 1.767A1.326 1.326 0 0 1 2.287.5a1.316 1.316 0 0 1 1.287 1.267M1.129 5.449c0-.762.485-.643 1.158-.643s1.148-.119 1.148.643v7.424c0 .772-.485.614-1.148.614s-1.158.158-1.158-.614zm4.306.001c0-.426.158-.585.405-.634s1.099 0 1.396 0s.416.485.406.851a2.49 2.49 0 0 1 2.217-.99a2.97 2.97 0 0 1 3.148 3.098v5.068c0 .772-.475.614-1.149.614c-.673 0-1.148.158-1.148-.614V8.884A1.425 1.425 0 0 0 9.206 7.34A1.435 1.435 0 0 0 7.74 8.914v3.959c0 .772-.485.614-1.158.614s-1.148.158-1.148-.614V5.449Z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
